












































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ModalState } from '@/models'

import BrandImage from './BrandImage.vue'
import VsLoading from './VsLoading.vue'

@Component({
  components: {
    BrandImage,
    VsLoading
  }
})
export default class UpdateBrandModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  selectImage = false

  loadBrandState: boolean | null = null

  imageFile: File | null = null

  get buttonsText () {
    return this.selectImage
      ? {
        acceptText: 'Enviar',
        cancelText: 'Cancelar'
      }
      : {
        acceptText: 'Alterar',
        cancelText: 'Fechar'
      }
  }

  get didErrorLoadingBrand () {
    return this.loadBrandState === false
  }

  get didLoadBrand () {
    return this.loadBrandState === true
  }

  get isLoadingBrand () {
    return this.loadBrandState === null
  }

  get isValid () {
    return !this.selectImage || this.imageFile !== null
  }

  changeImageFile (_: string, files: File[]) {
    this.imageFile = files[0]
  }

  clear () {
    this.imageFile = null
    this.selectImage = false
    this.loadBrandState = null
  }

  cancel () {
    this.modalState.reset()

    this.clear()

    this.$emit('cancel')
  }

  submit () {
    if (!this.isValid) {
      return
    }

    this.$emit('submit', {
      file: this.imageFile,
      callback: this.clear
    })

    this.imageFile = null
  }

  handleAccept () {
    if (this.selectImage) {
      this.submit()
    } else {
      this.modalState.isActive = true
      this.selectImage = true
    }
  }
}
